import React, { Component } from 'react';
import CustomFieldLine from './optionblocks/customFieldLine';

class MapCustomFields extends Component {
  state = {};
  render() {
    const {
      fields,
      customMeta,
      onFieldAdd,
      onFieldDelete,
      onFieldChange
    } = this.props;

    return (
      <div className="gb-settings-container">
        {fields &&
          fields.map(field => {
            return (
              <CustomFieldLine
                key={field.id}
                field={field}
                options={customMeta}
                onFieldChange={onFieldChange}
                onFieldDelete={onFieldDelete}
              />
            );
          })}
        {!fields.length && <p>No custom fields added.</p>}
        <button type="button" className="button" onClick={onFieldAdd}>
          Add Custom Field
        </button>
      </div>
    );
  }
}

export default MapCustomFields;



// WEBPACK FOOTER //
// ./src/components/settings/mapCustomFields.jsx